var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarranty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 450 450",
    width: 450,
    height: 450,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6698-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 0.9,
    y1: -7.4,
    x2: 449.2,
    y2: -7.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eebe47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ffee96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a2621e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#eea54c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eebe47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 230.2,
    y1: -94.3,
    x2: 619.4,
    y2: 294.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eebe47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ffee96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a2621e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#eea54c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eebe47"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g3",
    cx: 224.7,
    cy: 224.7,
    r: 197.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#cb1919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#700000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g4",
    x1: 214.9,
    y1: 515.8,
    x2: -107.5,
    y2: 193.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eebe47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ffee96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a2621e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#eea54c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eebe47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g5",
    x1: 221.4,
    y1: -54.2,
    x2: 496.2,
    y2: 174.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eebe47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ffee96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a2621e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#eea54c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eebe47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g6",
    x1: 214.9,
    y1: 447.2,
    x2: -20.2,
    y2: 212.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eebe47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ffee96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a2621e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#eea54c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eebe47"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g7",
    cx: 84,
    cy: -34,
    r: 400.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#cb1919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#700000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g8",
    cx: 300,
    cy: -19,
    r: 373.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc94c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#a2621e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g9",
    cx: 232.4,
    cy: 435.6,
    r: 585.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#cb1919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#700000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g10",
    x1: 164.5,
    y1: 99.9,
    x2: 428,
    y2: 253.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eebe47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ffee96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a2621e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#eea54c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eebe47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g11",
    x1: 170.8,
    y1: 89,
    x2: 434.3,
    y2: 242.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eebe47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ffee96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a2621e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#eea54c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eebe47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g12",
    x1: 176.8,
    y1: 78.8,
    x2: 440.2,
    y2: 232.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eebe47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ffee96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a2621e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#eea54c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eebe47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g13",
    x1: 187.9,
    y1: 59.6,
    x2: 451.4,
    y2: 212.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eebe47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ffee96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a2621e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#eea54c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eebe47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g14",
    x1: 130.7,
    y1: 215.5,
    x2: 370.4,
    y2: 354.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eebe47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ffee96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a2621e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#eea54c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eebe47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g15",
    x1: 137.5,
    y1: 203.8,
    x2: 377.2,
    y2: 343.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eebe47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ffee96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a2621e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#eea54c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eebe47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g16",
    x1: 146.5,
    y1: 188.3,
    x2: 386.2,
    y2: 327.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eebe47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ffee96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a2621e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#eea54c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eebe47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g17",
    x1: 154.7,
    y1: 174.3,
    x2: 394.3,
    y2: 313.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eebe47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ffee96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a2621e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#eea54c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eebe47"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g18",
    cx: 113.3,
    cy: 50.2,
    r: 360.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#ffc94c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#a2621e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g19",
    x1: 151.4,
    y1: 156.5,
    x2: 417.8,
    y2: 311.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eebe47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ffee96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a2621e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#eea54c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eebe47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g20",
    x1: 149.2,
    y1: 160,
    x2: 415.8,
    y2: 315.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eebe47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ffee96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a2621e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#eea54c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eebe47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g21",
    x1: 158.3,
    y1: 144.4,
    x2: 424.8,
    y2: 299.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eebe47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ffee96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a2621e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#eea54c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eebe47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g22",
    x1: 166.6,
    y1: 130.1,
    x2: 433.2,
    y2: 285.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eebe47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ffee96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a2621e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#eea54c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eebe47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g23",
    x1: 174.9,
    y1: 115.8,
    x2: 441.5,
    y2: 270.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eebe47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ffee96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a2621e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#eea54c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eebe47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g24",
    x1: 172.9,
    y1: 94.2,
    x2: 467,
    y2: 265.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eebe47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ffee96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a2621e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#eea54c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eebe47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g25",
    x1: 176.4,
    y1: 248.5,
    x2: 426.3,
    y2: 393.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eebe47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ffee96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a2621e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#eea54c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eebe47"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g26",
    cx: 214,
    cy: 365.9,
    r: 111.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc94c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#a2621e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g27",
    cx: 364.1,
    cy: 205.1,
    r: 108.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc94c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#a2621e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: url(#g1) } \r\n\t\t.s1 { fill: url(#g2) } \r\n\t\t.s2 { fill: url(#g3) } \r\n\t\t.s3 { fill: url(#g4) } \r\n\t\t.s4 { fill: url(#g5) } \r\n\t\t.s5 { fill: url(#g6) } \r\n\t\t.s6 { fill: url(#g7) } \r\n\t\t.s7 { mix-blend-mode: screen;fill: url(#g8) } \r\n\t\t.s8 { fill: #000000 } \r\n\t\t.s9 { fill: url(#g9) } \r\n\t\t.s10 { fill: url(#g10) } \r\n\t\t.s11 { fill: url(#g11) } \r\n\t\t.s12 { fill: url(#g12) } \r\n\t\t.s13 { fill: url(#g13) } \r\n\t\t.s14 { fill: url(#g14) } \r\n\t\t.s15 { fill: url(#g15) } \r\n\t\t.s16 { fill: url(#g16) } \r\n\t\t.s17 { fill: url(#g17) } \r\n\t\t.s18 { mix-blend-mode: screen;fill: url(#g18) } \r\n\t\t.s19 { fill: url(#g19) } \r\n\t\t.s20 { fill: url(#g20) } \r\n\t\t.s21 { fill: url(#g21) } \r\n\t\t.s22 { fill: url(#g22) } \r\n\t\t.s23 { fill: url(#g23) } \r\n\t\t.s24 { fill: url(#g24) } \r\n\t\t.s25 { fill: url(#g25) } \r\n\t\t.s26 { mix-blend-mode: screen;fill: url(#g26) } \r\n\t\t.s27 { mix-blend-mode: screen;fill: url(#g27) } \r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "<Group> copy 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m385.6 381.5l-25.7 2.7-6.9 24.9-25.8-2.2-11.4 23.1-24.9-7-15.6 20.6-23.1-11.7-19.2 17.3-20.5-15.8-22.1 13.3-17.1-19.3-24.3 8.8-13.2-22.2-25.5 4.1-8.6-24.4-25.9-0.7-3.9-25.6-25.2-5.6 1-25.9-23.7-10.3 5.8-25.2-21.3-14.6 10.5-23.6-18.1-18.4 14.8-21.2-14.4-21.5 18.6-18-10.1-23.8 21.7-14.2-5.4-25.3 23.9-9.8-0.4-25.9 25.3-5.1 4.5-25.5 25.8-0.2 9.2-24.2 25.4 4.7 13.6-22 24.1 9.4 17.5-19 21.9 13.8 20.8-15.4 18.9 17.7 23.3-11.2 15.2 20.9 25-6.5 10.9 23.4 25.8-1.7 6.4 25.1 25.6 3.2 1.5 25.8 24.5 8.1-3.4 25.6 22.6 12.5-8.2 24.5 19.8 16.6-12.7 22.5 16.3 20-16.7 19.7 12.2 22.8-20.2 16.2 7.8 24.6-22.9 12.1 2.9 25.7-24.7 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m426.4 224.7c0 111.4-90.3 201.7-201.7 201.7-111.4 0-201.8-90.3-201.8-201.7 0-111.5 90.4-201.8 201.8-201.8 111.4 0 201.7 90.3 201.7 201.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m27.6 224.7c0-108.9 88.2-197.2 197.1-197.2 108.8 0 197.1 88.3 197.1 197.2 0 108.8-88.3 197.1-197.1 197.1-108.9 0-197.1-88.3-197.1-197.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m411.2 224.7c0 103-83.5 186.5-186.5 186.5-103 0-186.6-83.5-186.6-186.5 0-103.1 83.6-186.6 186.6-186.6 103 0 186.5 83.5 186.5 186.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m406.8 224.7c0 100.5-81.6 182-182.1 182-100.6 0-182.1-81.5-182.1-182 0-100.6 81.5-182.1 182.1-182.1 100.5 0 182.1 81.5 182.1 182.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m367.1 224.7c0 78.6-63.8 142.3-142.4 142.3-78.6 0-142.4-63.7-142.4-142.3 0-78.7 63.8-142.4 142.4-142.4 78.6 0 142.4 63.7 142.4 142.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m362.5 224.7c0 76.1-61.7 137.8-137.8 137.8-76.1 0-137.8-61.7-137.8-137.8 0-76.2 61.7-137.9 137.8-137.9 76.1 0 137.8 61.7 137.8 137.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m86.9 224.7c0-76.2 61.7-137.9 137.8-137.9 47.8 0 89.9 24.4 114.7 61.4-47.5 23.6-91.3 54.7-129.2 92.7-27.6 27.6-51.6 58.3-71.7 91.2-31.5-25.2-51.6-64-51.6-107.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m78 143.8l1.4 3.5q-2 1.3-2.3 2.1-0.3 0.6-0.1 1.3 0.3 0.7 0.9 1 1.3 0.6 3.3-1.3 1.6-1.3 2.6-1.9 1-0.6 2.3-0.7 1.3-0.1 2.5 0.5 2.3 1.1 3.1 3.6 0.8 2.6-0.4 5.1-1.3 2.7-5.1 4.1l-1.7-3.8q2.5-0.9 3.2-2.3 0.3-0.7 0-1.6-0.3-0.9-0.9-1.2-1.4-0.6-3.8 1.7-1.4 1.4-2.2 1.8-0.9 0.4-2.1 0.4-1.2 0-2.3-0.5-2.3-1.1-3-3.3-0.7-2.2 0.5-4.6 1.3-2.8 4.1-3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s8",
    d: "m82.7 132l1.7-2.7 20.4 3.7-2.2 3.5-4-0.7-3.9 6.2 2.3 3.3-2.2 3.5zm6.2 2l3.6 4.9 2.4-3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m90 121.1l8-10.1 3.2 2.6-2.7 3.4 11.8 9.4-2.6 3.2-11.8-9.4-2.7 3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m101 107.8l2.8-3 14 13.1-2.8 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m116.9 94.6l0.1 3.8q-2.3 0.5-3 1.1-0.5 0.5-0.5 1.2 0 0.7 0.4 1.3 1 1 3.6 0 1.9-0.7 3.1-0.8 1.1-0.2 2.4 0.2 1.3 0.4 2.2 1.4 1.6 1.8 1.4 4.5-0.2 2.7-2.2 4.6-2.2 2-6.3 1.9l-0.1-4.2q2.6 0.2 3.8-0.9 0.5-0.5 0.6-1.5 0-0.9-0.5-1.5-1-1.1-4.1 0.2-1.8 0.8-2.7 0.9-1 0-2.1-0.4-1.1-0.5-1.9-1.3-1.7-1.9-1.6-4.2 0.2-2.3 2.2-4.1 2.3-2.2 5.2-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m120.1 89.7l8.7-6.4 2.2 2.9-5.4 4 2.4 3.2 5.4-4 2.2 3-5.3 4 4.7 6.2-3.3 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s8",
    d: "m137.5 77.7l2.7-1.7 16.5 12.5-3.6 2.2-3.2-2.5-6.3 3.8 0.6 4-3.6 2.1zm4.6 4.6l1 6 3.9-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m164 65.4l1.9 4.3q-3.6-0.5-5.8 0.5-2.1 0.9-2.7 3-0.7 2 0.5 4.5 1 2.4 3 3.2 2 0.8 4.2-0.3 2-0.8 4-3.7l1.9 4.3q-2.6 2.4-4.6 3.3-3.6 1.6-7.2 0.1-3.6-1.5-5.3-5.2-1.7-3.8-0.4-7.6 1.3-3.7 4.9-5.3 2.4-1.1 5.6-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m167.4 63.1l12.2-4 1.3 3.9-4.2 1.3 4.6 14.4-3.9 1.3-4.6-14.4-4.2 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m183.9 58.1l4-1 4.5 18.7-4 0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s8",
    d: "m194.5 65.2q-0.5-4.2 1.9-7.3 2.4-3.1 6.2-3.6 4.3-0.6 7.4 1.8 3.1 2.4 3.7 6.6 0.5 4.2-1.8 7.3-2.4 3.2-6.6 3.7-4.1 0.6-7.2-1.8-3-2.4-3.6-6.7zm8.8-7.2q-2.4 0.3-3.6 2.2-1.3 1.9-0.9 4.6 0.3 2.5 2 4 1.8 1.4 4 1.2 2.4-0.4 3.7-2.2 1.2-1.8 0.9-4.5-0.4-2.7-2-4.1-1.7-1.4-4.1-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m231.4 53.1l4 0.1-0.3 19.1h-4l-8.6-12.6-0.2 12.5-4.1-0.1 0.3-19.2 4.1 0.1 8.6 12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m275.5 65.1l-3.3 1.7q-0.5-1.6-1.5-2.7-1-1-2.4-1.4-2.2-0.6-4.2 0.6-2.1 1.2-2.7 3.5-0.6 2.4 0.5 4.5 1.2 2.1 3.4 2.7 1.3 0.3 2.6 0 1.3-0.3 2.4-1.8l-4.4-1.2 1-3.6 8.6 2.3-0.7 2.4q-0.5 1.8-2.3 3.6-1.9 1.8-4.2 2.2-2.4 0.4-4.5-0.2-3.8-1-5.7-4.5-1.9-3.5-0.8-7.6 1.1-3.9 4.6-5.9 3.4-2 7.2-0.9 4.9 1.3 6.4 6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m283.3 63.4l3.7 1.6-4.6 10.8q-0.6 1.5-0.2 2.8 0.5 1.2 1.8 1.8 1.6 0.7 2.9 0.1 1.2-0.5 1.9-2.2l4.5-10.6 3.8 1.6-4.9 11.4q-0.6 1.5-2.1 2.8-1.5 1.3-3.4 1.5-2 0.1-4-0.7-3.7-1.6-4.5-4.3-0.8-2.7 0.1-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s8",
    d: "m308.2 75.3l2.8 1.6-3 20.5-3.6-2.1 0.6-4-6.4-3.8-3.2 2.5-3.5-2.1zm-1.8 6.3l-4.8 3.7 3.9 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s8",
    d: "m322.2 84.1l4.9 3.9q2.3 1.7 2.7 4 0.4 2.2-1.2 4.2-0.9 1.2-2.5 2-1.6 0.8-3.8 0.2l-0.6 9.6-3.8-2.9 0.7-8.9-0.4-0.3-4.6 5.9-3.2-2.6zm1.2 5.3l-3.1 3.9 0.7 0.6q2.5 2 4.2-0.1 0.6-0.9 0.4-1.9-0.3-1-1.5-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s8",
    d: "m342.5 101.4l2.3 2.3-8.2 19.1-2.9-3 1.6-3.7-5.2-5.3-3.7 1.6-2.9-2.9zm-3.4 5.5l-5.6 2.4 3.2 3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m361.5 123.8l2.4 3.3-15.4 11.4-2.4-3.2 4.7-14.5-10 7.4-2.4-3.3 15.4-11.4 2.4 3.3-4.6 14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m366.6 131.3l6.4 11.2-3.5 2.1-2.2-3.8-13.1 7.5-2.1-3.6 13.1-7.5-2.2-3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m375.2 147l4.4 9.8-3.4 1.6-2.8-6.1-3.5 1.6 2.7 6.1-3.4 1.5-2.7-6.1-3.6 1.6 2.7 6.1-3.5 1.6-4.4-9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m381.7 162.1l3.4 10.2-3.6 1.2-2.1-6.3-3.7 1.3 2.1 6.3-3.5 1.2-2.1-6.3-3.8 1.2 2.1 6.3-3.6 1.2-3.4-10.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m87.2 299.5l-3.6-0.9q0.1-2.3-0.3-3-0.3-0.6-1-0.8-0.6-0.2-1.3 0.2-1.2 0.6-0.9 3.3 0.2 1.9 0.1 3-0.1 1.1-0.8 2.2-0.7 1.1-1.8 1.7-2.1 1.1-4.6 0.3-2.5-0.9-3.7-3.2-1.3-2.5-0.3-6.3l4 0.9q-0.8 2.4-0.1 3.7 0.3 0.7 1.2 1 0.9 0.2 1.5-0.1 1.3-0.7 0.8-3.9-0.2-1.8-0.1-2.7 0.2-0.9 0.9-1.9 0.7-0.9 1.6-1.4 2.2-1.2 4.3-0.5 2.1 0.7 3.3 3 1.5 2.7 0.8 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s8",
    d: "m93.9 307.1l1.8 2.5-11 16.6-2.3-3.3 2.2-3.2-4-5.9-3.8 0.9-2.3-3.3zm-4.1 4.7l-5.7 1.2 2.4 3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m99.9 315.7l8 9.5-3 2.5-2.7-3.2-11.2 9.3-2.5-3.1 11.1-9.3-2.7-3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m109.8 327.1l2.8 2.9-13.3 12.8-2.8-2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m121.9 341.1l-3.6 0.3q-0.7-2.1-1.3-2.7-0.5-0.5-1.2-0.4-0.7 0-1.1 0.5-1 1.1 0.2 3.5 0.8 1.7 1.1 2.8 0.3 1.1 0 2.4-0.3 1.2-1.2 2.2-1.6 1.7-4.2 1.7-2.6 0.1-4.5-1.7-2.1-1.9-2.4-5.8l4-0.5q0.1 2.5 1.2 3.5 0.5 0.5 1.5 0.5 0.9 0 1.3-0.6 1-1-0.5-3.9-0.9-1.6-1-2.5-0.2-0.9 0.1-2.1 0.4-1.1 1.1-1.9 1.7-1.8 3.9-1.9 2.2-0.1 4.1 1.7 2.3 2 2.5 4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m125.7 342.1l8.4 6.2-2.2 2.8-5.2-3.8-2.2 3 5.2 3.8-2.2 2.9-5.1-3.8-4.5 6.1-3.2-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s8",
    d: "m140.7 352.7l2.6 1.6-3.3 19.7-3.4-2.1 0.7-3.9-6.1-3.7-3.1 2.3-3.4-2.1zm-1.9 5.9l-4.7 3.5 3.8 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m163 365.7l-1.9 4q-1.9-2.9-4-3.9-2-0.9-3.9-0.1-1.9 0.8-3 3.2-1.1 2.2-0.4 4.1 0.6 2 2.8 3 1.8 0.9 5.2 0.7l-2 4q-3.4-0.4-5.3-1.4-3.4-1.6-4.5-5.2-1.2-3.6 0.5-7.1 1.7-3.6 5.3-5 3.6-1.3 7 0.3 2.2 1.1 4.2 3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m165.2 365.5l11.7 4.2-1.4 3.7-4-1.5-4.9 13.7-3.8-1.3 5-13.7-3.9-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m179.5 370.4l3.8 1.1-5 17.8-3.9-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s8",
    d: "m184.7 381.7q0.8-4.1 3.9-6.2 3.2-2.1 6.8-1.4 4.1 0.7 6.2 3.8 2.2 3.2 1.4 7.2-0.7 4-3.8 6.1-3.2 2.2-7.1 1.5-4-0.8-6.1-3.9-2-3.1-1.3-7.1zm10.2-4q-2.2-0.4-3.9 0.9-1.7 1.4-2.2 3.9-0.5 2.4 0.7 4.3 1.1 1.9 3.3 2.3 2.2 0.4 3.9-0.9 1.7-1.3 2.2-3.9 0.5-2.5-0.6-4.3-1.1-1.8-3.4-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m220 377l3.9 0.2-1 18.4-3.9-0.2-7.7-12.4-0.7 11.9-4-0.2 1-18.4 4 0.2 7.8 12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m259.8 377.3l-2.2 2.9q-1-1.3-2.4-1.8-1.3-0.5-2.6-0.2-2.1 0.3-3.4 2.2-1.3 1.9-0.9 4.1 0.4 2.4 2.2 3.7 1.9 1.4 4.1 1 1.2-0.2 2.2-1 1-0.8 1.4-2.6l-4.3 0.7-0.6-3.5 8.4-1.5 0.4 2.4q0.3 1.8-0.6 4.1-0.9 2.3-2.7 3.6-1.9 1.3-4 1.7-3.7 0.6-6.8-1.6-3.1-2.3-3.8-6.3-0.6-3.9 1.6-7 2.2-3.2 5.9-3.8 4.8-0.9 8.1 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m263.2 372.3l3.8-1.1 3.2 10.8q0.5 1.5 1.6 2.2 1.1 0.7 2.5 0.2 1.5-0.4 2.1-1.6 0.6-1.2 0.1-2.9l-3.2-10.6 3.7-1.1 3.5 11.4q0.4 1.5 0.1 3.4-0.2 1.8-1.6 3.2-1.4 1.3-3.4 1.9-3.6 1.1-5.9-0.4-2.3-1.5-3-3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s8",
    d: "m286 364.5l2.8-1.2 14.3 13.9-3.7 1.6-2.8-2.7-6.5 2.8 0.1 3.9-3.6 1.6zm3.8 4.9l0.2 5.9 4-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s8",
    d: "m298.1 359l5.2-3.1q2.4-1.4 4.5-0.9 2.2 0.4 3.4 2.6 0.7 1.2 0.9 2.9 0.1 1.7-1.2 3.4l8.4 4.1-4 2.3-7.7-3.8-0.4 0.3 3.6 6.1-3.4 2zm5.1 0.9l2.4 4.1 0.7-0.4q2.7-1.6 1.5-3.8-0.6-0.9-1.6-1-1-0.1-2.2 0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s8",
    d: "m317.7 346.5l2.4-1.8 17.1 10.2-3.2 2.4-3.3-2-5.7 4.3 1 3.8-3.2 2.3zm4.9 4l1.5 5.6 3.5-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m337 329.8l2.8-2.7 12.8 13.2-2.7 2.7-14.4-2.7 8.3 8.6-2.9 2.8-12.8-13.2 2.8-2.8 14.3 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m341.4 325.2l7.9-9.6 3 2.5-2.7 3.3 11.2 9.3-2.5 3.1-11.2-9.3-2.7 3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m351 313.4l5.9-8.6 3 2.1-3.7 5.3 3.1 2.1 3.7-5.3 2.9 2.1-3.6 5.3 3.1 2.1 3.7-5.2 3 2-5.9 8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m358.8 301.8l5.1-9 3.2 1.8-3.2 5.5 3.3 1.9 3.1-5.6 3.2 1.8-3.2 5.6 3.3 1.9 3.2-5.6 3.2 1.8-5.2 9z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m79.5 235.5l-9.1-5.4-9.2 5.4 2.4-10.4-8-7 10.6-1 4.2-9.7 4.2 9.7 10.6 1-8 7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s10",
    d: "m187.6 162.7h-5.2v-35.8h-3.5v-4.3h8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s11",
    d: "m208.4 122q4.7 0 6.9 4.3 2.3 4.3 2.3 16.1 0 9.7-1 13.3-1 3.7-3 5.6-2 1.9-5.2 1.9-3.3 0-5.5-2.3-2.1-2.3-2.8-6.3-0.8-4-0.8-13.2 0-8.1 0.9-11.7 0.9-3.6 2.9-5.7 2-2 5.3-2zm3.4 17.1v-1.4q0-4.7-0.2-6.3-0.2-1.7-1.1-3.1-0.8-1.5-2.2-1.5-2 0-2.7 2.6-0.7 2.6-0.7 8.6v1.3l0.1 1.3v1.5l-0.1 3.4v0.9q0 6.4 0.7 9.2 0.6 2.8 2.8 2.8 1.4 0 2.1-1.2 0.8-1.2 1-3.6 0.2-2.4 0.2-11.2v-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s12",
    d: "m231.9 122q4.7 0 6.9 4.3 2.3 4.3 2.3 16.1 0 9.7-1 13.3-1 3.7-3 5.6-1.9 1.9-5.2 1.9-3.3 0-5.5-2.3-2.1-2.3-2.8-6.3-0.8-4-0.8-13.2 0-8.1 0.9-11.7 0.9-3.6 2.9-5.7 2-2 5.3-2zm3.4 17.1v-1.4q0-4.7-0.2-6.3-0.2-1.7-1.1-3.1-0.8-1.5-2.2-1.5-2 0-2.7 2.6-0.7 2.6-0.7 8.6v1.3l0.1 1.3v1.5l-0.1 3.4v0.9q0 6.4 0.7 9.2 0.6 2.8 2.8 2.8 1.4 0 2.1-1.2 0.8-1.2 1-3.6 0.2-2.4 0.2-11.2v-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s13",
    d: "m253.7 121.9q2.7 0 4.5 2.3 1.7 2.3 1.7 10.8 0 7.4-1.8 10-1.7 2.7-4.5 2.7-2.6 0-4.3-2.6-1.7-2.5-1.7-10.7 0-8 2-10.3 1.9-2.2 4-2.2zm-2 12.9q-0.1 0.9-0.1 2.5 0 3.8 0.4 5.4 0.5 1.6 1.6 1.6 1.3 0 1.9-2.1 0.5-2.1 0.5-6.7 0-6.2-0.4-8.2-0.4-2-1.7-2-0.7 0-1.2 0.7-0.6 0.7-0.6 1.8zm27-13.2l-21.9 43.3h-3.1l21.8-43.3zm0 17.1q3.3 0 4.7 3.1 1.3 3.1 1.3 10.3 0 12.4-6.4 12.4-2.5 0-4.2-2.3-1.6-2.3-1.6-10 0-9.4 2.1-11.5 2.1-2 4.1-2zm1.9 13q0.1-0.9 0.1-2.7 0-3.8-0.4-5.3-0.3-1.6-1.6-1.6-1.3 0-1.8 2-0.6 1.9-0.6 6.3 0 6.8 0.4 8.7 0.4 1.9 1.7 1.9 0.7 0 1.3-0.6 0.5-0.6 0.6-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s14",
    d: "m172.2 256.3h7.4q6.1 0 9 3 2.9 3 2.9 9.3 0 9-6.9 11.4 7.5 1.5 7.5 11.8 0 5.6-2.7 8.7-2.7 3-7.7 3h-9.5zm6.3 4.9v16.4q3.6-0.1 5.3-1.9 1.6-1.7 1.6-6.2 0-4.7-1.4-6.5-1.4-1.8-5.5-1.8zm0 21.1v16.5q3.8-0.1 5.4-1.7 1.6-1.5 1.6-6.1 0-4.9-1.6-6.8-1.7-1.8-5.4-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s15",
    d: "m222.2 303.5h-6.1l-1.8-9.3h-10l-1.7 9.3h-6.1l10.2-47.2h5.2zm-8.7-14.1l-4.1-22.4h-0.2l-3.9 22.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s16",
    d: "m247.3 302.7q-2.8 1.4-5.7 1.4-5.7 0-9.9-4.4-4.1-4.4-4.1-18.5 0-15.2 4.1-20.4 4.2-5.3 10.2-5.3 2.2 0 5.4 0.7v5.8q-2.1-0.8-4-0.8-3.7 0-6.3 3.7-2.7 3.8-2.7 14.9 0 6.6 0.6 10.3 0.6 3.8 2.7 6 2 2.2 5.2 2.2 1.8 0 4.5-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s17",
    d: "m279.8 303.5h-7.3l-10.3-23.9h-0.1v23.9h-6.5v-47.2h6.5v23.4h0.1l11-23.4h6.5l-11.5 22.9z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s18",
    d: "m161 347l63.5-122.3-60.2 124q-1.6-0.9-3.3-1.7zm-13.7-8.2l77.2-114.1-74.1 116.1c-1.1-0.7-2.1-1.3-3.1-2zm59.4 22.5l17.8-136.6-14.1 137c-1.3-0.1-2.5-0.3-3.7-0.4zm-72.1-32.3l89.9-104.3-87.1 106.7q-1.4-1.2-2.8-2.4zm56.3 29.3l33.6-133.6-29.9 134.5q-1.8-0.4-3.7-0.9zm-15.2-4.8l48.8-128.8-45.3 130.1q-1.8-0.6-3.5-1.3zm-71.4-61.6l120.2-67.2-118.4 70.5q-0.9-1.6-1.8-3.3zm-12.3-29.5l132.5-37.7-131.5 41.2c-0.4-1.1-0.7-2.3-1-3.5zm-3.5-15.6l136-22.1-135.3 25.7q-0.4-1.8-0.7-3.6zm8.7 30.7l127.3-52.8-125.8 56.2q-0.7-1.7-1.5-3.4zm15.7 27.9l111.6-80.7-109.4 83.7q-1.1-1.5-2.2-3zm109.8 57l1.8-137.7 1.9 137.7c-0.6 0-1.3 0.1-1.9 0.1-0.6 0-1.2-0.1-1.8-0.1zm31.8-3.2l-30-134.5 33.6 133.6q-1.8 0.5-3.6 0.9zm95.8-78.3l-125.8-56.2 127.3 52.8q-0.7 1.7-1.5 3.4zm-16.4 27.5l-109.4-83.7 111.7 80.7q-1.1 1.5-2.3 3zm9-13.2l-118.4-70.5 120.3 67.2q-0.9 1.7-1.9 3.3zm13.1-29.3l-131.5-41.2 132.6 37.7c-0.4 1.2-0.7 2.4-1.1 3.5zm-131.5-41.2l137.7 6.1q-0.1 1.9-0.3 3.7zm135.4 25.8l-135.4-25.8 136.1 22.1q-0.3 1.9-0.7 3.7zm-36.4 70.1l-99-95.9 101.6 93.2q-1.3 1.4-2.6 2.7zm-38.8 28.1l-60.2-124 63.5 122.3q-1.6 0.9-3.3 1.7zm-14.8 6.2l-45.4-130.2 48.9 128.9q-1.7 0.6-3.5 1.3zm-183-124l137.6-6.2-137.4 9.9q-0.1-1.9-0.2-3.7zm151.8 130.9l-14.2-137.1 17.9 136.6c-1.2 0.2-2.4 0.4-3.7 0.5zm60-20.9l-74.2-116.2 77.3 114.1c-1 0.7-2.1 1.4-3.1 2.1zm13-9.4l-87.2-106.8 90 104.4q-1.4 1.2-2.8 2.4zm-188.7-13.6l101.5-93.2-98.9 95.9q-1.3-1.3-2.6-2.7zm203.1-186.4l-101.6 93.2 99-95.9q1.3 1.4 2.6 2.7zm-11.6-11.1l-90 104.3 87.2-106.8q1.4 1.2 2.8 2.5zm-26.5-18l-63.5 122.3 60.2-124q1.7 0.8 3.3 1.7zm13.8 8.2l-77.3 114.1 74.2-116.1c1 0.6 2.1 1.3 3.1 2zm-43.7-19.6l-33.6 133.7 30-134.5q1.8 0.4 3.6 0.8zm15.3 4.8l-48.9 128.9 45.4-130.1q1.8 0.6 3.5 1.2zm62.8 48.1l-111.7 80.8 109.5-83.7q1.1 1.4 2.2 2.9zm24.4 58.7l-136.1 22.1 135.4-25.8q0.4 1.9 0.7 3.7zm-118.2-114.5l-17.9 136.6 14.2-137.1c1.3 0.1 2.5 0.3 3.7 0.5zm119.8 130.5l-137.7 6.1 137.5-9.9q0.1 1.9 0.2 3.8zm-5.1-31.6l-132.6 37.7 131.6-41.3c0.3 1.2 0.6 2.4 1 3.6zm-5.3-15.1l-127.3 52.8 125.8-56.3q0.8 1.7 1.5 3.5zm-7-14.5l-120.3 67.3 118.5-70.5q0.9 1.6 1.8 3.2zm-194.4-48.8l74.1 116.1-77.2-114.1c1-0.7 2.1-1.4 3.1-2zm-44.3 45.6l118.4 70.5-120.2-67.3q0.9-1.6 1.8-3.2zm-7.4 14.2l125.8 56.3-127.2-52.8q0.7-1.8 1.4-3.5zm26.9-39.6l98.9 95.9-101.5-93.2q1.3-1.3 2.6-2.7zm-10.5 12.2l109.4 83.7-111.6-80.8q1.1-1.5 2.2-2.9zm-25.9 57.9l135.3 25.8-136-22.1q0.3-1.8 0.7-3.7zm3.8-15.5l131.5 41.3-132.5-37.7c0.3-1.2 0.7-2.4 1-3.6zm86.2-88.8l45.3 130.1-48.8-128.8q1.7-0.7 3.5-1.3zm15.4-4.4l29.9 134.5-33.5-133.7q1.8-0.4 3.6-0.8zm-57.2 27.7l87.1 106.8-89.9-104.3q1.4-1.3 2.8-2.5zm73-30.3l14.1 137.1-17.8-136.6c1.2-0.2 2.4-0.4 3.7-0.5zm16-0.7l-1.9 137.8-1.8-137.8c0.6 0 1.2 0 1.8 0 0.7 0 1.3 0 1.9 0zm-62 13.8l60.1 124-63.5-122.3q1.7-0.9 3.4-1.7zm-77.3 114.1l137.4 9.9-137.6-6.1q0.1-1.9 0.2-3.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s19",
    d: "m133.6 232.8q-7.6 14.1-14.3 14.1-4.2 0-4.2-4.3 0-2.6 2-5.8 3.4-5.4 10.7-13.2 7.2-7.8 12.2-12.4l3.2-10.8q-4.2 3.9-10.9 4.6-0.8 0-0.8-0.5-0.1-0.6 0.7-0.8l0.3-0.1q3.6-0.3 7.4-3.8 3.8-3.4 5.8-7.8 0.3-1.1 2.9-1.1 2.6 0.1 2.5 1.1l-5.8 14.3q11.4-9.6 16.4-9.9 0.5 0 1.1 0 6.6 0 9.2 4.4 2.1 3.7 2.1 8.6 0 7.4-4.5 21.1-0.7 2.4-0.6 2.5 0.1 0 0.4-0.5 0.4-0.6 1.1-1.7 0.7-1 3.4-5.5 9.6-16.2 19.6-27 3.3-3.4 6.5-3.4 2 0 3 1.3 1 1.4 1 3 0 1.6-0.7 4.4-0.8 2.9-4.4 11.9-4.4 11.1-4.4 18.1 0 5.5 3 5.5 2.2 0 5.8-2.8 5.5-4.6 8.9-9.1 0.4-0.6 0.8-0.3 0.3 0.3 0.3 0.6 0 0.2-0.1 0.3-1.6 2.5-5.1 6.1-5.6 5.9-9 7-1.7 0.6-3.3 0.6-5.5-0.1-5.5-8 0-4.1 1-7.9 1-3.9 1.6-6 0.7-2.1 1.7-4.9 1-2.8 1.7-4.3 2.1-5.4 2.6-6.8 0.5-1.3 0.5-2.3 0-0.9-0.5-1.3-0.5-0.4-1.3-0.4-0.8 0-2.6 1.5-6.5 5.5-14.5 17.4-8.1 11.9-11.4 18.7-0.7 1.4-1.3 1.4-0.7 0-1.5-1.2-0.7-1.2-0.7-1.7 0-0.6 0.1-0.7 2.2-5.6 3.1-11.9 1-6.2 1-10.3 0-14.1-6.1-14.1-5.7 0-20.7 13.7-0.8 2.2-3.3 7.9-3.4 7.4-6.1 12.5zm-14 11.3q5.2 0 12.7-14.5 4.2-8.1 6.1-13.1-4.5 4.2-9.8 10.3-5.4 6.1-7.7 9.1-2.9 3.9-2.9 6 0 2.2 1.6 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s20",
    d: "m228.3 230.3q1.5-3.1 1.5-4.7 0-1.7-0.4-2.7-0.4-0.9 0.3-1.6 0.7-0.7 1.8-0.5 1.7 0.4 1.7 3.8 0 3.3-3.9 8.8 0 2.2 2.3 2.2 2.3 0 6.9-4.8 2.2-2.6 2.7-3.3 0.5-0.8 1-0.5 0.4 0.2 0.4 0.3 0 0.9-3 4.4-4.8 5.9-8.5 5.9-2.4 0-3.4-2.1-1.7 1.7-3.3 3.2-3.3 2.8-7.3 2.8-2.2 0-3.8-1.1-2.9-1.8-2.9-6.3 0-4.9 3.4-10 1.9-3.1 4.5-5.3 4.1-3.6 7.8-3.6 0.9 0 1.7 0.2 2.6 0.9 2.6 3.2 0 1.9-1.1 1.9-0.4-0.1-0.4-1.2 0-1.5-1.7-1.5-2.9 0-7.5 5.3-4.6 5.4-5.5 10.8-0.2 1-0.2 2.1 0 1.1 0.8 2.6 0.7 1.5 2.8 1.5 2 0 4.5-1.9 2.4-1.8 4.3-4.7l-0.2-0.5q-0.4-1.3 0.3-2.2 0.7-0.8 1.8-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s21",
    d: "m263.7 215.8q1.9 0 1.9 2 0 2.1-1.9 5.7-1.9 3.6-2.9 5.8-1.5 3.9-1.5 6.2 0 2.3 0.6 3.1 1.3 1.3 3.5 0.1 2.1-1.2 6-4.7 3.9-3.5 6.3-6.8 0.3-0.5 0.8-0.2 0.4 0.2 0.4 0.4 0 0.2-0.1 0.4-1.3 2.3-4.6 5.8-3.2 3.5-6.2 5.7-3.1 2.1-6 2.1-2.8-0.1-4-1.3-1.2-1.2-1.2-3.1 0-1.8 0.3-3.5 0.4-1.7 1.3-4 1.5-3.6 2.6-5.6 1.2-2 1.2-2.6 0-0.7-0.7-0.7-1.3 0-5.1 3.3-2.6 2.4-7.7 9.2-5 6.7-5.7 7.1-3 1.5-3.8 1.5-0.7 0-0.7-0.2 0-0.3 0.1-0.7 0.2-0.5 1.7-4.6 1.4-4.1 3.2-9 1.7-4.9 2-5.9 0.4-1 0.6-1.7 0.1-0.7 0.2-1.2 0.2-0.5 0.7-1.2 0.4-0.6 1.2-0.6 0.7-0.1 1.9 0.1 1.2 0.2 1.2 1.1 0 0.6-0.9 2.5-1 2-5.3 13.6 3-3.7 7.6-8.5 4.6-4.9 7.8-7.4 3.2-2.2 5.2-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s22",
    d: "m293.9 215.2q4.6 0 4.6 4.3 0 2.3-1.3 3.7-2.1 3.1-6.8 5.4-4.7 2.3-7.9 2.6-1.2 0.1-1.3-0.7-0.1-0.3 0.2-0.4 0.3-0.1 0.5-0.1 1.9-0.2 4.9-1.8 5.6-3 8.2-6.2 1.1-1.5 1.1-2.9 0-1.4-1.3-1.4-1.1 0-3 0.9-3.9 1.9-8.2 6.4-4.4 4.6-5.7 8.9-0.5 1.4-0.5 2.7 0 1.3 1.1 2.5 1.1 1.1 3.4 1.1 2.5 0 5.8-1.3 9.4-3.9 14.5-11.7 0.5-0.6 1-0.2 0.3 0.2 0.3 0.4 0 0.3-0.3 0.6-2.5 4.2-6.3 7.5-7.5 6.3-14.5 6.3-6.1 0-8.5-3.6-0.9-1.4-0.9-3.4 0-2 1.1-4.8 2.1-4.8 8.9-9.8 6.9-5 10.9-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s23",
    d: "m299.1 271.5q-0.6 0-1.6-0.3-4.3-1.1-4.3-4.5 0-3.3 4.4-8.5 4.4-5.1 18.5-14.4 7.9-16.1 10-22.6-1 1.2-3.9 5.1-3 3.9-5.2 6.6-2.3 2.7-5.5 5.2-3.2 2.4-5.8 2.4-2.7 0-4.2-1.2-1.4-1.2-1.6-2.6-0.2-1.3-0.2-2.3 0-3 1.7-6.1 2.5-5.2 6.8-8.8 1.6-1.6 2.8-1.6 1.2 0 2.2 0.8 1.1 1.2 0.7 2-3.2 1.9-7.3 7.1-2.2 2.9-3 7.2-0.1 0.6-0.1 1.5 0 0.9 0.7 1.4 0.7 0.6 1.5 0.6 2.6 0 5.4-2.8 2.9-2.8 5.5-5.8 2.6-3.1 5.9-7.3 3.3-4.3 4.3-5.7 1.1-1.3 2.2-1.3 1.3 0 2.7 0.8 1.4 0.7 1.2 1.1-0.2 0.4-4.2 9.5-4.1 9.1-5.9 13.1 2-1.1 6.8-5.2 4.8-4.1 8.2-8.2 0.8-1 1-0.2 0.1 0.2 0.1 0.5 0 0.4-0.5 1.1-2.6 3.4-8.3 8.6-5.7 5.2-9 7.1-7.1 14.6-9.6 18.4-6.2 9.3-12.4 9.3zm15.4-24.6q-10 7.6-14.3 11.9-4.3 4.4-4.3 7.5 0 3.2 2.1 3.2 1.7 0 3.9-1.7 2.2-1.8 4.2-4.6 2-2.9 3-4.9 1.1-2.1 2.9-6 1.9-4 2.5-5.4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s24",
    d: "m296.7 177.8h-140.3v-2.3h140.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s25",
    d: "m280.8 320.8h-119v-2.3h119z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m325.7 365.9c0 22.4-50 40.4-111.7 40.4-61.7 0-111.7-18-111.7-40.4 0-22.3 50-40.4 111.7-40.4 61.7 0 111.7 18.1 111.7 40.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s27",
    d: "m381.7 315.4c-22 3.6-47.8-43-57.6-103.9-9.7-60.9 0.2-113.2 22.3-116.7 22-3.5 47.8 43 57.6 103.9 9.7 60.9-0.2 113.2-22.3 116.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarranty);
export default __webpack_public_path__ + "static/media/warranty.2a7b2559d95156c6448774f7ab8f4488.svg";
export { ForwardRef as ReactComponent };